import { render, staticRenderFns } from "./fanmenu.vue?vue&type=template&id=01f82e45&scoped=true&"
import script from "./fanmenu.vue?vue&type=script&lang=js&"
export * from "./fanmenu.vue?vue&type=script&lang=js&"
import style0 from "./fanmenu.vue?vue&type=style&index=0&id=01f82e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f82e45",
  null
  
)

export default component.exports